export const capitalize = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const tipoClass = (tipo) => {
  const t = (tipo || "").toLowerCase();
  return {
    "badge-comunidad": t === "comunidad",
    "badge-institucion": t === "institución" || t === "institucion",
    "badge-fundacion": t === "fundación" || t === "fundacion",
  };
};
